import { createContext, useContext } from 'react';
const EMPTY_ARRAY = [];
const DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select(_name) {
        console.error(constructMissingProviderErrorMessage('get', 'select'));
    },
    connect(decryptPermission, network) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'connect')));
    },
    disconnect() {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'disconnect')));
    },
    signMessage(_message) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'signMessage')));
    },
    decrypt(_cipherText, _tpk, _programId, _functionName, _index) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'decrypt')));
    },
    requestViewKey() {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'requestViewKey')));
    },
    requestRecords(_program) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'requestRecords')));
    },
    requestTransaction(_transaction) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'requestTransaction')));
    },
    requestBulkTransactions(_transactions) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'requestBulkTransactions')));
    },
    requestDeploy(_deployment) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'requestDeploy')));
    },
    transactionStatus(_transactionId) {
        return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'transactionStatus')));
    },
};
Object.defineProperty(DEFAULT_CONTEXT, 'wallets', {
    get() {
        console.error(constructMissingProviderErrorMessage('read', 'wallets'));
        return EMPTY_ARRAY;
    },
});
Object.defineProperty(DEFAULT_CONTEXT, 'wallet', {
    get() {
        console.error(constructMissingProviderErrorMessage('read', 'wallet'));
        return null;
    },
});
Object.defineProperty(DEFAULT_CONTEXT, 'publicKey', {
    get() {
        console.error(constructMissingProviderErrorMessage('read', 'publicKey'));
        return null;
    },
});
Object.defineProperty(DEFAULT_CONTEXT, 'viewKey', {
    get() {
        console.error(constructMissingProviderErrorMessage('read', 'viewKey'));
        return null;
    },
});
function constructMissingProviderErrorMessage(action, valueName) {
    return ('You have tried to ' +
        ` ${action} "${valueName}"` +
        ' on a WalletContext without providing one.' +
        ' Make sure to render a WalletProvider' +
        ' as an ancestor of the component that uses ' +
        'WalletContext');
}
export const WalletContext = createContext(DEFAULT_CONTEXT);
export function useWallet() {
    return useContext(WalletContext);
}
//# sourceMappingURL=useWallet.js.map